import type { IBadgeProps as Props } from "./types";
import styles from "./badge.module.scss";
import { getColor } from "./getColor";

import { Tooltip } from "@components/atoms/tooltip";

function Badge(props: Props) {
  const { role, value } = props;

  return (
    <Tooltip text={value}>
      <div
        className={styles.badge}
        style={{ backgroundColor: getColor(role) }}
      />
    </Tooltip>
  );
}

export { Badge };
